import { FSharpRef, Union, Record } from "../client/fable_modules/fable-library.4.10.0/Types.js";
import { tuple_type, unit_type, lambda_type, decimal_type, list_type, bool_type, option_type, int32_type, anonRecord_type, class_type, union_type, record_type, string_type } from "../client/fable_modules/fable-library.4.10.0/Reflection.js";
import { FSharpResult$2 } from "../client/fable_modules/fable-library.4.10.0/Choice.js";
import { printf, toText, join } from "../client/fable_modules/fable-library.4.10.0/String.js";
import { filter, tryFind, head as head_1, isEmpty, reverse, initialize, indexed, tryItem, length, singleton, append, mapIndexed, ofArray, map, choose } from "../client/fable_modules/fable-library.4.10.0/List.js";
import { map as map_1 } from "../client/fable_modules/fable-library.4.10.0/Array.js";
import { totalSeconds } from "../client/fable_modules/fable-library.4.10.0/TimeSpan.js";
import { op_Subtraction } from "../client/fable_modules/fable-library.4.10.0/Date.js";
import { defaultOf, int32ToString, equals } from "../client/fable_modules/fable-library.4.10.0/Util.js";
import { value as value_1, map as map_2, defaultArg } from "../client/fable_modules/fable-library.4.10.0/Option.js";
import { fromParts } from "../client/fable_modules/fable-library.4.10.0/Decimal.js";
import { FSharpMap__TryGetValue, FSharpMap__Add } from "../client/fable_modules/fable-library.4.10.0/Map.js";
import { match } from "../client/fable_modules/fable-library.4.10.0/RegExp.js";
import { parse } from "../client/fable_modules/fable-library.4.10.0/Int32.js";

export class REQ$1 extends Record {
    constructor(Token, Arg) {
        super();
        this.Token = Token;
        this.Arg = Arg;
    }
}

export function REQ$1_$reflection(gen0) {
    return record_type("OpenQuiz.Shared.REQ`1", [gen0], REQ$1, () => [["Token", string_type], ["Arg", gen0]]);
}

export class ServerResponseStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Executed", "SecurityTokenInvalid", "SecurityTokenExpired", "Unauthorized"];
    }
}

export function ServerResponseStatus_$reflection() {
    return union_type("OpenQuiz.Shared.ServerResponseStatus", [], ServerResponseStatus, () => [[], [], [], []]);
}

export class RESP$1 extends Record {
    constructor(Status, Value, ST) {
        super();
        this.Status = Status;
        this.Value = Value;
        this.ST = ST;
    }
}

export function RESP$1_$reflection(gen0) {
    return record_type("OpenQuiz.Shared.RESP`1", [gen0], RESP$1, () => [["Status", ServerResponseStatus_$reflection()], ["Value", union_type("Microsoft.FSharp.Core.FSharpResult`2", [gen0, string_type], FSharpResult$2, () => [[["ResultValue", gen0]], [["ErrorValue", string_type]]])], ["ST", class_type("System.DateTime")]]);
}

export class TRESP$2 extends Record {
    constructor(Tag, Rsp) {
        super();
        this.Tag = Tag;
        this.Rsp = Rsp;
    }
}

export function TRESP$2_$reflection(gen0, gen1) {
    return record_type("OpenQuiz.Shared.TRESP`2", [gen0, gen1], TRESP$2, () => [["Tag", gen0], ["Rsp", RESP$1_$reflection(gen1)]]);
}

export class LoginReq extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MainUser", "AdminUser", "TeamUser", "RegUser", "AudUser"];
    }
}

export function LoginReq_$reflection() {
    return union_type("OpenQuiz.Shared.LoginReq", [], LoginReq, () => [[["Item", anonRecord_type(["Code", string_type])]], [["Item", anonRecord_type(["QuizId", int32_type], ["Token", string_type])]], [["Item", anonRecord_type(["QuizId", int32_type], ["TeamId", int32_type], ["Token", string_type])]], [["Item", anonRecord_type(["QuizId", int32_type], ["Token", string_type])]], [["Item", anonRecord_type(["QuizId", int32_type], ["Token", string_type])]]]);
}

export class User extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MainUser", "AdminUser", "TeamUser", "RegUser", "AudUser"];
    }
}

export function User_$reflection() {
    return union_type("OpenQuiz.Shared.User", [], User, () => [[["Item", MainUser_$reflection()]], [["Item", AdminUser_$reflection()]], [["Item", TeamUser_$reflection()]], [["Item", RegUser_$reflection()]], [["Item", AudUser_$reflection()]]]);
}

export class MainUser extends Record {
    constructor(Sub, Username, Name, PictureUrl, IsProducer, IsPrivate) {
        super();
        this.Sub = Sub;
        this.Username = Username;
        this.Name = Name;
        this.PictureUrl = PictureUrl;
        this.IsProducer = IsProducer;
        this.IsPrivate = IsPrivate;
    }
}

export function MainUser_$reflection() {
    return record_type("OpenQuiz.Shared.MainUser", [], MainUser, () => [["Sub", string_type], ["Username", string_type], ["Name", string_type], ["PictureUrl", option_type(string_type)], ["IsProducer", bool_type], ["IsPrivate", bool_type]]);
}

export class AppSyncConfig extends Record {
    constructor(Endpoint, Region, ApiKey) {
        super();
        this.Endpoint = Endpoint;
        this.Region = Region;
        this.ApiKey = ApiKey;
    }
}

export function AppSyncConfig_$reflection() {
    return record_type("OpenQuiz.Shared.AppSyncConfig", [], AppSyncConfig, () => [["Endpoint", string_type], ["Region", string_type], ["ApiKey", string_type]]);
}

export class TeamUser extends Record {
    constructor(QuizId, QuizName, TeamId, TeamName, AppSyncCfg, ContentHost) {
        super();
        this.QuizId = (QuizId | 0);
        this.QuizName = QuizName;
        this.TeamId = (TeamId | 0);
        this.TeamName = TeamName;
        this.AppSyncCfg = AppSyncCfg;
        this.ContentHost = ContentHost;
    }
}

export function TeamUser_$reflection() {
    return record_type("OpenQuiz.Shared.TeamUser", [], TeamUser, () => [["QuizId", int32_type], ["QuizName", string_type], ["TeamId", int32_type], ["TeamName", string_type], ["AppSyncCfg", AppSyncConfig_$reflection()], ["ContentHost", string_type]]);
}

export class AdminUser extends Record {
    constructor(QuizId, QuizName, QuizImg, ResultsToken, ContentHost) {
        super();
        this.QuizId = (QuizId | 0);
        this.QuizName = QuizName;
        this.QuizImg = QuizImg;
        this.ResultsToken = ResultsToken;
        this.ContentHost = ContentHost;
    }
}

export function AdminUser_$reflection() {
    return record_type("OpenQuiz.Shared.AdminUser", [], AdminUser, () => [["QuizId", int32_type], ["QuizName", string_type], ["QuizImg", string_type], ["ResultsToken", string_type], ["ContentHost", string_type]]);
}

export class AudUser extends Record {
    constructor(QuizId, AppSyncCfg, ContentHost) {
        super();
        this.QuizId = (QuizId | 0);
        this.AppSyncCfg = AppSyncCfg;
        this.ContentHost = ContentHost;
    }
}

export function AudUser_$reflection() {
    return record_type("OpenQuiz.Shared.AudUser", [], AudUser, () => [["QuizId", int32_type], ["AppSyncCfg", AppSyncConfig_$reflection()], ["ContentHost", string_type]]);
}

export class RegUser extends Record {
    constructor(QuizId) {
        super();
        this.QuizId = (QuizId | 0);
    }
}

export function RegUser_$reflection() {
    return record_type("OpenQuiz.Shared.RegUser", [], RegUser, () => [["QuizId", int32_type]]);
}

export class Settings extends Record {
    constructor(MediaHost) {
        super();
        this.MediaHost = MediaHost;
    }
}

export function Settings_$reflection() {
    return record_type("OpenQuiz.Shared.Settings", [], Settings, () => [["MediaHost", string_type]]);
}

export class MediaCategory extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["QuizImg", "QuestionImg", "QuestionVideo"];
    }
}

export function MediaCategory_$reflection() {
    return union_type("OpenQuiz.Shared.MediaCategory", [], MediaCategory, () => [[], [], []]);
}

export class QuizStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Setup", "Live", "Finished"];
    }
}

export function QuizStatus_$reflection() {
    return union_type("OpenQuiz.Shared.QuizStatus", [], QuizStatus, () => [[], [], []]);
}

export class TeamStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["New", "Admitted", "Rejected"];
    }
}

export function TeamStatus_$reflection() {
    return union_type("OpenQuiz.Shared.TeamStatus", [], TeamStatus, () => [[], [], []]);
}

export class TourStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Announcing", "Countdown", "Settled"];
    }
}

export function TourStatus_$reflection() {
    return union_type("OpenQuiz.Shared.TourStatus", [], TourStatus, () => [[], [], []]);
}

export class SlipQwCard extends Record {
    constructor(Txt, Choices, Media, Ch, Points) {
        super();
        this.Txt = Txt;
        this.Choices = Choices;
        this.Media = Media;
        this.Ch = Ch;
        this.Points = Points;
    }
}

export function SlipQwCard_$reflection() {
    return record_type("OpenQuiz.Shared.SlipQwCard", [], SlipQwCard, () => [["Txt", string_type], ["Choices", option_type(list_type(string_type))], ["Media", option_type(MediaDsc_$reflection())], ["Ch", bool_type], ["Points", decimal_type]]);
}

export class ChoiceAnswer extends Record {
    constructor(Text$, IsCorrect) {
        super();
        this.Text = Text$;
        this.IsCorrect = IsCorrect;
    }
}

export function ChoiceAnswer_$reflection() {
    return record_type("OpenQuiz.Shared.ChoiceAnswer", [], ChoiceAnswer, () => [["Text", string_type], ["IsCorrect", bool_type]]);
}

export class SlipAnswer extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["OpenAnswer", "ChoiceAnswer"];
    }
}

export function SlipAnswer_$reflection() {
    return union_type("OpenQuiz.Shared.SlipAnswer", [], SlipAnswer, () => [[["Item", string_type]], [["Item", list_type(ChoiceAnswer_$reflection())]]]);
}

export class SlipAwCard extends Record {
    constructor(Aw, Media, Com, Ch) {
        super();
        this.Aw = Aw;
        this.Media = Media;
        this.Com = Com;
        this.Ch = Ch;
    }
}

export function SlipAwCard_$reflection() {
    return record_type("OpenQuiz.Shared.SlipAwCard", [], SlipAwCard, () => [["Aw", SlipAnswer_$reflection()], ["Media", option_type(MediaDsc_$reflection())], ["Com", string_type], ["Ch", bool_type]]);
}

export class SingleSlipCard extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["X3", "QW", "AW"];
    }
}

export function SingleSlipCard_$reflection() {
    return union_type("OpenQuiz.Shared.SingleSlipCard", [], SingleSlipCard, () => [[], [["Item", SlipQwCard_$reflection()]], [["Item", SlipAwCard_$reflection()]]]);
}

export class QwKey extends Record {
    constructor(TourIdx, QwIdx) {
        super();
        this.TourIdx = (TourIdx | 0);
        this.QwIdx = (QwIdx | 0);
    }
}

export function QwKey_$reflection() {
    return record_type("OpenQuiz.Shared.QwKey", [], QwKey, () => [["TourIdx", int32_type], ["QwIdx", int32_type]]);
}

export class SlipCard extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SS", "MS"];
    }
}

export function SlipCard_$reflection() {
    return union_type("OpenQuiz.Shared.SlipCard", [], SlipCard, () => [[["Item", SingleSlipCard_$reflection()]], [["name", string_type], ["slips", list_type(SingleSlipCard_$reflection())]]]);
}

export class TourCard extends Record {
    constructor(Idx, Name, Sec, TS, Slip, ST) {
        super();
        this.Idx = (Idx | 0);
        this.Name = Name;
        this.Sec = (Sec | 0);
        this.TS = TS;
        this.Slip = Slip;
        this.ST = ST;
    }
}

export function TourCard_$reflection() {
    return record_type("OpenQuiz.Shared.TourCard", [], TourCard, () => [["Idx", int32_type], ["Name", string_type], ["Sec", int32_type], ["TS", TourStatus_$reflection()], ["Slip", SlipCard_$reflection()], ["ST", option_type(class_type("System.DateTime"))]]);
}

export class QuizChangedEvent extends Record {
    constructor(Id, QS, Url, T) {
        super();
        this.Id = (Id | 0);
        this.QS = QS;
        this.Url = Url;
        this.T = T;
    }
}

export function QuizChangedEvent_$reflection() {
    return record_type("OpenQuiz.Shared.QuizChangedEvent", [], QuizChangedEvent, () => [["Id", int32_type], ["QS", QuizStatus_$reflection()], ["Url", option_type(string_type)], ["T", option_type(TourCard_$reflection())]]);
}

export class Slip extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Single", "Multiple"];
    }
}

export function Slip_$reflection() {
    return union_type("OpenQuiz.Shared.Slip", [], Slip, () => [[["Item", SingleSlip_$reflection()]], [["Item1", string_type], ["Item2", list_type(SingleSlip_$reflection())]]]);
}

export class Question extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Solid", "Split"];
    }
}

export function Question_$reflection() {
    return union_type("OpenQuiz.Shared.Question", [], Question, () => [[["Item", string_type]], [["Item", list_type(string_type)]]]);
}

export class MediaType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Picture", "Audio", "Video"];
    }
}

export function MediaType_$reflection() {
    return union_type("OpenQuiz.Shared.MediaType", [], MediaType, () => [[], [], []]);
}

export class MediaDsc extends Record {
    constructor(Key, Type) {
        super();
        this.Key = Key;
        this.Type = Type;
    }
}

export function MediaDsc_$reflection() {
    return record_type("OpenQuiz.Shared.MediaDsc", [], MediaDsc, () => [["Key", string_type], ["Type", MediaType_$reflection()]]);
}

export class SingleSlip extends Record {
    constructor(Caption, Question, QuestionMedia, Answer, AnswerMedia, Comment$, Points, JeopardyPoints, WithChoice, Seconds, EndOfTour) {
        super();
        this.Caption = Caption;
        this.Question = Question;
        this.QuestionMedia = QuestionMedia;
        this.Answer = Answer;
        this.AnswerMedia = AnswerMedia;
        this.Comment = Comment$;
        this.Points = Points;
        this.JeopardyPoints = JeopardyPoints;
        this.WithChoice = WithChoice;
        this.Seconds = Seconds;
        this.EndOfTour = EndOfTour;
    }
}

export function SingleSlip_$reflection() {
    return record_type("OpenQuiz.Shared.SingleSlip", [], SingleSlip, () => [["Caption", string_type], ["Question", Question_$reflection()], ["QuestionMedia", option_type(MediaDsc_$reflection())], ["Answer", SlipAnswer_$reflection()], ["AnswerMedia", option_type(MediaDsc_$reflection())], ["Comment", string_type], ["Points", decimal_type], ["JeopardyPoints", option_type(decimal_type)], ["WithChoice", bool_type], ["Seconds", option_type(int32_type)], ["EndOfTour", bool_type]]);
}

export class PackageRecord extends Record {
    constructor(PackageId, Producer, Name) {
        super();
        this.PackageId = (PackageId | 0);
        this.Producer = Producer;
        this.Name = Name;
    }
}

export function PackageRecord_$reflection() {
    return record_type("OpenQuiz.Shared.PackageRecord", [], PackageRecord, () => [["PackageId", int32_type], ["Producer", string_type], ["Name", string_type]]);
}

export class PackageCard extends Record {
    constructor(PackageId, Name, Slips) {
        super();
        this.PackageId = (PackageId | 0);
        this.Name = Name;
        this.Slips = Slips;
    }
}

export function PackageCard_$reflection() {
    return record_type("OpenQuiz.Shared.PackageCard", [], PackageCard, () => [["PackageId", int32_type], ["Name", string_type], ["Slips", list_type(Slip_$reflection())]]);
}

export class ISecurityApi extends Record {
    constructor(login, refreshToken) {
        super();
        this.login = login;
        this.refreshToken = refreshToken;
    }
}

export function ISecurityApi_$reflection() {
    return record_type("OpenQuiz.Shared.ISecurityApi", [], ISecurityApi, () => [["login", lambda_type(REQ$1_$reflection(LoginReq_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(anonRecord_type(["RefreshToken", string_type], ["Settings", Settings_$reflection()], ["Token", string_type], ["User", User_$reflection()]))]))], ["refreshToken", lambda_type(REQ$1_$reflection(anonRecord_type(["RefreshToken", string_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(anonRecord_type(["RefreshToken", string_type], ["Token", string_type]))]))]]);
}

export class IMainApi extends Record {
    constructor(becomeProducer, createQuiz, getProdQuizzes, getProdQuizCard, updateProdQuizCard, deleteQuiz, getRegModel, registerTeam, getProdPackages, getProdPackageCard, createPackage, updateProdPackageCard, aquirePackage, deletePackage, getSettings, updateSettings, sharePackage, removePackageShare, getUploadUrl) {
        super();
        this.becomeProducer = becomeProducer;
        this.createQuiz = createQuiz;
        this.getProdQuizzes = getProdQuizzes;
        this.getProdQuizCard = getProdQuizCard;
        this.updateProdQuizCard = updateProdQuizCard;
        this.deleteQuiz = deleteQuiz;
        this.getRegModel = getRegModel;
        this.registerTeam = registerTeam;
        this.getProdPackages = getProdPackages;
        this.getProdPackageCard = getProdPackageCard;
        this.createPackage = createPackage;
        this.updateProdPackageCard = updateProdPackageCard;
        this.aquirePackage = aquirePackage;
        this.deletePackage = deletePackage;
        this.getSettings = getSettings;
        this.updateSettings = updateSettings;
        this.sharePackage = sharePackage;
        this.removePackageShare = removePackageShare;
        this.getUploadUrl = getUploadUrl;
    }
}

export function IMainApi_$reflection() {
    return record_type("OpenQuiz.Shared.IMainApi", [], IMainApi, () => [["becomeProducer", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(unit_type)]))], ["createQuiz", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(anonRecord_type(["Card", MainModels_QuizProdCard_$reflection()], ["Record", MainModels_QuizProdRecord_$reflection()]))]))], ["getProdQuizzes", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(list_type(MainModels_QuizProdRecord_$reflection()))]))], ["getProdQuizCard", lambda_type(REQ$1_$reflection(anonRecord_type(["QuizId", int32_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(MainModels_QuizProdCard_$reflection())]))], ["updateProdQuizCard", lambda_type(REQ$1_$reflection(MainModels_QuizProdCard_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(MainModels_QuizProdRecord_$reflection())]))], ["deleteQuiz", lambda_type(REQ$1_$reflection(anonRecord_type(["QuizId", int32_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(unit_type)]))], ["getRegModel", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(MainModels_QuizRegRecord_$reflection())]))], ["registerTeam", lambda_type(REQ$1_$reflection(anonRecord_type(["TeamName", string_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(MainModels_QuizRegRecord_$reflection())]))], ["getProdPackages", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(list_type(PackageRecord_$reflection()))]))], ["getProdPackageCard", lambda_type(REQ$1_$reflection(anonRecord_type(["PackageId", int32_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(MainModels_PackageCard_$reflection())]))], ["createPackage", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(anonRecord_type(["Card", MainModels_PackageCard_$reflection()], ["Record", PackageRecord_$reflection()]))]))], ["updateProdPackageCard", lambda_type(REQ$1_$reflection(MainModels_PackageCard_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(PackageRecord_$reflection())]))], ["aquirePackage", lambda_type(REQ$1_$reflection(anonRecord_type(["PackageId", int32_type], ["TransferToken", string_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(PackageRecord_$reflection())]))], ["deletePackage", lambda_type(REQ$1_$reflection(anonRecord_type(["PackageId", int32_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(unit_type)]))], ["getSettings", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(MainModels_SettingsCard_$reflection())]))], ["updateSettings", lambda_type(REQ$1_$reflection(MainModels_SettingsCard_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(MainModels_SettingsCard_$reflection())]))], ["sharePackage", lambda_type(REQ$1_$reflection(anonRecord_type(["PackageId", int32_type], ["UserId", string_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(MainModels_ExpertRecord_$reflection())]))], ["removePackageShare", lambda_type(REQ$1_$reflection(anonRecord_type(["PackageId", int32_type], ["UserId", string_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(unit_type)]))], ["getUploadUrl", lambda_type(REQ$1_$reflection(anonRecord_type(["Cat", MediaCategory_$reflection()])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(anonRecord_type(["BucketKey", string_type], ["Url", string_type]))]))]]);
}

export class IAdminApi extends Record {
    constructor(getTeams, createTeam, createTeamBatch, getTeamCard, updateTeamCard, changeTeamStatus, getQuizCard, changeQuizStatus, changeStreamUrl, getPackages, setPackage, getPackageCard, startCountDown, pauseCountDown, settleTour, nextTour, nextQuestion, nextQuestionPart, showMedia, showQuestion, getAnswers, updateResults, updateResultsWithoutAnswer, getListenToken) {
        super();
        this.getTeams = getTeams;
        this.createTeam = createTeam;
        this.createTeamBatch = createTeamBatch;
        this.getTeamCard = getTeamCard;
        this.updateTeamCard = updateTeamCard;
        this.changeTeamStatus = changeTeamStatus;
        this.getQuizCard = getQuizCard;
        this.changeQuizStatus = changeQuizStatus;
        this.changeStreamUrl = changeStreamUrl;
        this.getPackages = getPackages;
        this.setPackage = setPackage;
        this.getPackageCard = getPackageCard;
        this.startCountDown = startCountDown;
        this.pauseCountDown = pauseCountDown;
        this.settleTour = settleTour;
        this.nextTour = nextTour;
        this.nextQuestion = nextQuestion;
        this.nextQuestionPart = nextQuestionPart;
        this.showMedia = showMedia;
        this.showQuestion = showQuestion;
        this.getAnswers = getAnswers;
        this.updateResults = updateResults;
        this.updateResultsWithoutAnswer = updateResultsWithoutAnswer;
        this.getListenToken = getListenToken;
    }
}

export function IAdminApi_$reflection() {
    return record_type("OpenQuiz.Shared.IAdminApi", [], IAdminApi, () => [["getTeams", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(list_type(AdminModels_TeamRecord_$reflection()))]))], ["createTeam", lambda_type(REQ$1_$reflection(anonRecord_type(["TeamName", string_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(anonRecord_type(["Record", AdminModels_TeamRecord_$reflection()]))]))], ["createTeamBatch", lambda_type(REQ$1_$reflection(anonRecord_type(["TeamNames", list_type(string_type)])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(unit_type)]))], ["getTeamCard", lambda_type(REQ$1_$reflection(anonRecord_type(["TeamId", int32_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_TeamCard_$reflection())]))], ["updateTeamCard", lambda_type(REQ$1_$reflection(AdminModels_TeamCard_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_TeamRecord_$reflection())]))], ["changeTeamStatus", lambda_type(REQ$1_$reflection(anonRecord_type(["TeamId", int32_type], ["TeamStatus", TeamStatus_$reflection()])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_TeamRecord_$reflection())]))], ["getQuizCard", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["changeQuizStatus", lambda_type(REQ$1_$reflection(anonRecord_type(["QuizStatus", QuizStatus_$reflection()])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["changeStreamUrl", lambda_type(REQ$1_$reflection(string_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["getPackages", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(list_type(PackageRecord_$reflection()))]))], ["setPackage", lambda_type(REQ$1_$reflection(anonRecord_type(["PackageId", option_type(int32_type)])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["getPackageCard", lambda_type(REQ$1_$reflection(anonRecord_type(["PackageId", int32_type])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(PackageCard_$reflection())]))], ["startCountDown", lambda_type(REQ$1_$reflection(AdminModels_QuizControlCard_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["pauseCountDown", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["settleTour", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["nextTour", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["nextQuestion", lambda_type(REQ$1_$reflection(AdminModels_QuizControlCard_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["nextQuestionPart", lambda_type(REQ$1_$reflection(AdminModels_QuizControlCard_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["showMedia", lambda_type(REQ$1_$reflection(AdminModels_QuizControlCard_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["showQuestion", lambda_type(REQ$1_$reflection(AdminModels_QuizControlCard_$reflection()), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_QuizControlCard_$reflection())]))], ["getAnswers", lambda_type(REQ$1_$reflection(option_type(AdminModels_Range_$reflection())), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AdminModels_AnswersBundle_$reflection())]))], ["updateResults", lambda_type(REQ$1_$reflection(list_type(anonRecord_type(["QwKey", QwKey_$reflection()], ["Res", option_type(decimal_type)], ["TeamId", int32_type]))), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(unit_type)]))], ["updateResultsWithoutAnswer", lambda_type(REQ$1_$reflection(list_type(anonRecord_type(["QwKey", QwKey_$reflection()], ["Res", option_type(decimal_type)], ["TeamId", int32_type]))), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(unit_type)]))], ["getListenToken", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(string_type)]))]]);
}

export class ITeamApi extends Record {
    constructor(getState, takeActiveSession, answers, getHistory, vote) {
        super();
        this.getState = getState;
        this.takeActiveSession = takeActiveSession;
        this.answers = answers;
        this.getHistory = getHistory;
        this.vote = vote;
    }
}

export function ITeamApi_$reflection() {
    return record_type("OpenQuiz.Shared.ITeamApi", [], ITeamApi, () => [["getState", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(TeamModels_QuizCard_$reflection())]))], ["takeActiveSession", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(TeamModels_QuizCard_$reflection())]))], ["answers", lambda_type(REQ$1_$reflection(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [QwKey_$reflection(), tuple_type(string_type, bool_type)])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(unit_type)]))], ["getHistory", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(list_type(TeamModels_TeamHistoryRecord_$reflection()))]))], ["vote", lambda_type(REQ$1_$reflection(anonRecord_type(["Key", QwKey_$reflection()], ["Vote", option_type(bool_type)])), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(unit_type)]))]]);
}

export class IRegApi extends Record {
    constructor(getRecord) {
        super();
        this.getRecord = getRecord;
    }
}

export function IRegApi_$reflection() {
    return record_type("OpenQuiz.Shared.IRegApi", [], IRegApi, () => [["getRecord", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(RegModels_QuizRecord_$reflection())]))]]);
}

export class IAudApi extends Record {
    constructor(getQuiz, getHistory) {
        super();
        this.getQuiz = getQuiz;
        this.getHistory = getHistory;
    }
}

export function IAudApi_$reflection() {
    return record_type("OpenQuiz.Shared.IAudApi", [], IAudApi, () => [["getQuiz", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(AudModels_QuizCard_$reflection())]))], ["getHistory", lambda_type(REQ$1_$reflection(unit_type), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [RESP$1_$reflection(list_type(AudModels_HistoryRecord_$reflection()))]))]]);
}

export const Errors_SessionIsNotActive = "SESSION IS NOT ACTIVE";

export function MediaCategory__get_Prefix(x) {
    switch (x.tag) {
        case 1:
            return "qw";
        case 2:
            return "qv";
        default:
            return "qz";
    }
}

export function SlipAnswer__ToRawString(x) {
    if (x.tag === 1) {
        return join("\n", choose((ch) => {
            if (ch.IsCorrect) {
                return ch.Text;
            }
            else {
                return void 0;
            }
        }, x.fields[0]));
    }
    else {
        return x.fields[0];
    }
}

export function SlipAnswer__IsOpen(x) {
    if (x.tag === 0) {
        return true;
    }
    else {
        return false;
    }
}

export function SlipAnswer__ToOpen(x) {
    if (x.tag === 1) {
        return new SlipAnswer(0, [join("\n", map((ch) => ch.Text, x.fields[0]))]);
    }
    else {
        return x;
    }
}

export function SlipAnswer__ToChoice(x) {
    if (x.tag === 1) {
        return x;
    }
    else {
        return new SlipAnswer(1, [ofArray(map_1((txt_1) => (new ChoiceAnswer(txt_1, false)), x.fields[0].split("\n")))]);
    }
}

export function SlipAnswer__SetCorrectness(x, idx, isCorrect) {
    if (x.tag === 1) {
        return new SlipAnswer(1, [mapIndexed((i, ch) => {
            if (i === idx) {
                return new ChoiceAnswer(ch.Text, isCorrect);
            }
            else {
                return ch;
            }
        }, x.fields[0])]);
    }
    else {
        return x;
    }
}

export function SlipAnswer__SetText(x, idx, txt) {
    if (x.tag === 1) {
        return new SlipAnswer(1, [mapIndexed((i, ch) => {
            if (i === idx) {
                return new ChoiceAnswer(txt, ch.IsCorrect);
            }
            else {
                return ch;
            }
        }, x.fields[0])]);
    }
    else {
        return x;
    }
}

export function SlipAnswer__AppendChoice(x) {
    if (x.tag === 1) {
        return new SlipAnswer(1, [append(x.fields[0], singleton(new ChoiceAnswer("", false)))]);
    }
    else {
        return x;
    }
}

export function SlipAnswer__DeleteChoice_Z524259A4(x, idx) {
    if (x.tag === 1) {
        return new SlipAnswer(1, [choose((x_1) => x_1, mapIndexed((i, ch) => {
            if (i === idx) {
                return void 0;
            }
            else {
                return ch;
            }
        }, x.fields[0]))]);
    }
    else {
        return x;
    }
}

export function SlipCard__get_QwCount(x) {
    if (x.tag === 1) {
        return length(x.fields[1]) | 0;
    }
    else {
        return 1;
    }
}

export function TourCard__SecondsLeft_7F9DDECF(x, now) {
    const matchValue = x.ST;
    if (matchValue != null) {
        const matchValue_1 = ((x.Sec + 10) - ~~totalSeconds(op_Subtraction(now, matchValue))) | 0;
        if (matchValue_1 > 0) {
            return matchValue_1 | 0;
        }
        else {
            return 0;
        }
    }
    else {
        return x.Sec | 0;
    }
}

export function TourCard__IsCountdownActive_7F9DDECF(x, now) {
    let matchResult;
    if (x.ST != null) {
        if (equals(x.TS, new TourStatus(1, []))) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return TourCard__SecondsLeft_7F9DDECF(x, now) > 0;
        default:
            return false;
    }
}

export function TourCard__IsCountdownFinished_7F9DDECF(x, now) {
    let matchResult;
    if (x.ST != null) {
        if (equals(x.TS, new TourStatus(1, []))) {
            matchResult = 0;
        }
        else if (equals(x.TS, new TourStatus(2, []))) {
            matchResult = 1;
        }
        else {
            matchResult = 2;
        }
    }
    else if (equals(x.TS, new TourStatus(2, []))) {
        matchResult = 1;
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0:
            return TourCard__SecondsLeft_7F9DDECF(x, now) === 0;
        case 1:
            return true;
        default:
            return false;
    }
}

export function Slip__get_Caption(x) {
    if (x.tag === 1) {
        return "";
    }
    else {
        return x.fields[0].Caption;
    }
}

export function Slip__get_Annotation(x) {
    if (x.tag === 1) {
        return x.fields[0];
    }
    else {
        return SingleSlip__GetQwText_Z524259A4(x.fields[0], 0);
    }
}

export function Slip__get_LastQwIdx(x) {
    if (x.tag === 1) {
        return (length(x.fields[1]) - 1) | 0;
    }
    else {
        return 0;
    }
}

export function Slip__LastQwPartIdx_Z524259A4(x, qwIdx) {
    if (x.tag === 1) {
        return defaultArg(map_2(SingleSlip__get_LastPartIdx, tryItem(qwIdx, x.fields[1])), 0) | 0;
    }
    else {
        return SingleSlip__get_LastPartIdx(x.fields[0]) | 0;
    }
}

export function Slip__SetMultipleName_Z721C83C5(x, name) {
    if (x.tag === 1) {
        const tupledArg = [name, x.fields[1]];
        return new Slip(1, [tupledArg[0], tupledArg[1]]);
    }
    else {
        return x;
    }
}

export function Slip__AppendToMultiple_73903553(x, slip) {
    if (x.tag === 1) {
        const tupledArg = [x.fields[0], append(x.fields[1], singleton(slip))];
        return new Slip(1, [tupledArg[0], tupledArg[1]]);
    }
    else {
        return x;
    }
}

export function Slip__RemoveFromMultiple_Z524259A4(x, idx) {
    if (x.tag === 1) {
        const tupledArg_1 = [x.fields[0], choose((tupledArg) => {
            if (idx !== tupledArg[0]) {
                return tupledArg[1];
            }
            else {
                return void 0;
            }
        }, indexed(x.fields[1]))];
        return new Slip(1, [tupledArg_1[0], tupledArg_1[1]]);
    }
    else {
        return x;
    }
}

export function SingleSlip__SetQwText(x, idx, txt) {
    let matchValue;
    return new SingleSlip(x.Caption, (matchValue = x.Question, (matchValue.tag === 1) ? (new Question(1, [mapIndexed((i, qw) => {
        if (i === idx) {
            return txt;
        }
        else {
            return qw;
        }
    }, matchValue.fields[0])])) : (new Question(0, [txt]))), x.QuestionMedia, x.Answer, x.AnswerMedia, x.Comment, x.Points, x.JeopardyPoints, x.WithChoice, x.Seconds, x.EndOfTour);
}

export function SingleSlip__GetQwText_Z524259A4(x, idx) {
    const matchValue = x.Question;
    if (matchValue.tag === 1) {
        return defaultArg(tryItem(idx, matchValue.fields[0]), "");
    }
    else {
        return matchValue.fields[0];
    }
}

export function SingleSlip__get_LastPartIdx(x) {
    const matchValue = x.Question;
    if (matchValue.tag === 1) {
        return (length(matchValue.fields[0]) - 1) | 0;
    }
    else {
        return 0;
    }
}

export function SingleSlip_InitEmpty(caption, qwCount) {
    return new SingleSlip(caption, (qwCount === 1) ? (new Question(0, [""])) : (new Question(1, [initialize(qwCount, (i) => "")])), void 0, new SlipAnswer(0, [""]), void 0, "", fromParts(1, 0, 0, false, 0), void 0, false, void 0, false);
}

export function PackageCard__GetSlip_Z524259A4(x, idx) {
    return tryItem(idx, x.Slips);
}

export class RegModels_QuizRecord extends Record {
    constructor(QuizId, StartTime, Name, Status, Description, ImgKey, EventPage) {
        super();
        this.QuizId = (QuizId | 0);
        this.StartTime = StartTime;
        this.Name = Name;
        this.Status = Status;
        this.Description = Description;
        this.ImgKey = ImgKey;
        this.EventPage = EventPage;
    }
}

export function RegModels_QuizRecord_$reflection() {
    return record_type("OpenQuiz.Shared.RegModels.QuizRecord", [], RegModels_QuizRecord, () => [["QuizId", int32_type], ["StartTime", option_type(class_type("System.DateTime"))], ["Name", string_type], ["Status", QuizStatus_$reflection()], ["Description", string_type], ["ImgKey", string_type], ["EventPage", string_type]]);
}

export class MainModels_ExpertCompetition extends Record {
    constructor(QuizId, TeamId, TeamName, TeamStatus, EntryToken) {
        super();
        this.QuizId = (QuizId | 0);
        this.TeamId = (TeamId | 0);
        this.TeamName = TeamName;
        this.TeamStatus = TeamStatus;
        this.EntryToken = EntryToken;
    }
}

export function MainModels_ExpertCompetition_$reflection() {
    return record_type("OpenQuiz.Shared.MainModels.ExpertCompetition", [], MainModels_ExpertCompetition, () => [["QuizId", int32_type], ["TeamId", int32_type], ["TeamName", string_type], ["TeamStatus", TeamStatus_$reflection()], ["EntryToken", string_type]]);
}

export class MainModels_ExpertProfile extends Record {
    constructor(Competitions) {
        super();
        this.Competitions = Competitions;
    }
}

export function MainModels_ExpertProfile_$reflection() {
    return record_type("OpenQuiz.Shared.MainModels.ExpertProfile", [], MainModels_ExpertProfile, () => [["Competitions", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, MainModels_ExpertCompetition_$reflection()])]]);
}

export class MainModels_QuizRegRecord extends Record {
    constructor(QuizId, StartTime, Name, Status, Description, Information, ImgKey, EventPage, ListenToken, Comp) {
        super();
        this.QuizId = (QuizId | 0);
        this.StartTime = StartTime;
        this.Name = Name;
        this.Status = Status;
        this.Description = Description;
        this.Information = Information;
        this.ImgKey = ImgKey;
        this.EventPage = EventPage;
        this.ListenToken = ListenToken;
        this.Comp = Comp;
    }
}

export function MainModels_QuizRegRecord_$reflection() {
    return record_type("OpenQuiz.Shared.MainModels.QuizRegRecord", [], MainModels_QuizRegRecord, () => [["QuizId", int32_type], ["StartTime", option_type(class_type("System.DateTime"))], ["Name", string_type], ["Status", QuizStatus_$reflection()], ["Description", string_type], ["Information", string_type], ["ImgKey", string_type], ["EventPage", string_type], ["ListenToken", string_type], ["Comp", option_type(MainModels_ExpertCompetition_$reflection())]]);
}

export class MainModels_QuizProdRecord extends Record {
    constructor(QuizId, StartTime, Name, Status, AdminToken) {
        super();
        this.QuizId = (QuizId | 0);
        this.StartTime = StartTime;
        this.Name = Name;
        this.Status = Status;
        this.AdminToken = AdminToken;
    }
}

export function MainModels_QuizProdRecord_$reflection() {
    return record_type("OpenQuiz.Shared.MainModels.QuizProdRecord", [], MainModels_QuizProdRecord, () => [["QuizId", int32_type], ["StartTime", option_type(class_type("System.DateTime"))], ["Name", string_type], ["Status", QuizStatus_$reflection()], ["AdminToken", string_type]]);
}

export class MainModels_QuizProdCard extends Record {
    constructor(QuizId, StartTime, Name, ImgKey, ListenToken, ResultsToken, AdminToken, RegToken, WelcomeText, FarewellText, RegText, InfoText, WithPremoderation, EventPage, MixlrCode) {
        super();
        this.QuizId = (QuizId | 0);
        this.StartTime = StartTime;
        this.Name = Name;
        this.ImgKey = ImgKey;
        this.ListenToken = ListenToken;
        this.ResultsToken = ResultsToken;
        this.AdminToken = AdminToken;
        this.RegToken = RegToken;
        this.WelcomeText = WelcomeText;
        this.FarewellText = FarewellText;
        this.RegText = RegText;
        this.InfoText = InfoText;
        this.WithPremoderation = WithPremoderation;
        this.EventPage = EventPage;
        this.MixlrCode = MixlrCode;
    }
}

export function MainModels_QuizProdCard_$reflection() {
    return record_type("OpenQuiz.Shared.MainModels.QuizProdCard", [], MainModels_QuizProdCard, () => [["QuizId", int32_type], ["StartTime", option_type(class_type("System.DateTime"))], ["Name", string_type], ["ImgKey", string_type], ["ListenToken", string_type], ["ResultsToken", string_type], ["AdminToken", string_type], ["RegToken", string_type], ["WelcomeText", string_type], ["FarewellText", string_type], ["RegText", string_type], ["InfoText", string_type], ["WithPremoderation", bool_type], ["EventPage", string_type], ["MixlrCode", string_type]]);
}

export class MainModels_SettingsCard extends Record {
    constructor(UserId, DefaultImg, DefaultMixlr) {
        super();
        this.UserId = UserId;
        this.DefaultImg = DefaultImg;
        this.DefaultMixlr = DefaultMixlr;
    }
}

export function MainModels_SettingsCard_$reflection() {
    return record_type("OpenQuiz.Shared.MainModels.SettingsCard", [], MainModels_SettingsCard, () => [["UserId", string_type], ["DefaultImg", string_type], ["DefaultMixlr", string_type]]);
}

export class MainModels_ExpertRecord extends Record {
    constructor(Id, Name) {
        super();
        this.Id = Id;
        this.Name = Name;
    }
}

export function MainModels_ExpertRecord_$reflection() {
    return record_type("OpenQuiz.Shared.MainModels.ExpertRecord", [], MainModels_ExpertRecord, () => [["Id", string_type], ["Name", string_type]]);
}

export class MainModels_PackageCard extends Record {
    constructor(PackageId, Producer, Name, TransferToken, SharedWith, Slips) {
        super();
        this.PackageId = (PackageId | 0);
        this.Producer = Producer;
        this.Name = Name;
        this.TransferToken = TransferToken;
        this.SharedWith = SharedWith;
        this.Slips = Slips;
    }
}

export function MainModels_PackageCard_$reflection() {
    return record_type("OpenQuiz.Shared.MainModels.PackageCard", [], MainModels_PackageCard, () => [["PackageId", int32_type], ["Producer", string_type], ["Name", string_type], ["TransferToken", string_type], ["SharedWith", list_type(MainModels_ExpertRecord_$reflection())], ["Slips", list_type(Slip_$reflection())]]);
}

export function MainModels_ExpertProfile__UpdateCompetition_D8F266D(x, comp) {
    return new MainModels_ExpertProfile(FSharpMap__Add(x.Competitions, comp.QuizId, comp));
}

export function MainModels_PackageCard__GetSlip_Z524259A4(x, idx) {
    return tryItem(idx, x.Slips);
}

export function MainModels_PackageCard__AppendSlip_Z29327777(x, slip) {
    return new MainModels_PackageCard(x.PackageId, x.Producer, x.Name, x.TransferToken, x.SharedWith, append(x.Slips, singleton(slip)));
}

export function MainModels_PackageCard__UpdateSlip(x, idx, slip) {
    return new MainModels_PackageCard(x.PackageId, x.Producer, x.Name, x.TransferToken, x.SharedWith, mapIndexed((i, q) => {
        if (idx === i) {
            return slip;
        }
        else {
            return q;
        }
    }, x.Slips));
}

export function MainModels_PackageCard__DelSlip_Z524259A4(x, idx) {
    return new MainModels_PackageCard(x.PackageId, x.Producer, x.Name, x.TransferToken, x.SharedWith, choose((tupledArg) => {
        if (idx === tupledArg[0]) {
            return void 0;
        }
        else {
            return tupledArg[1];
        }
    }, indexed(x.Slips)));
}

export function MainModels_PackageCard__GetNextSlipCaption(x) {
    let copyOfStruct;
    const matchValue = reverse(x.Slips);
    if (!isEmpty(matchValue)) {
        const head = head_1(matchValue);
        const m = match(/([^\d]*)(\d+)/gu, Slip__get_Caption(head));
        if (m != null) {
            return (m[1] || "") + ((copyOfStruct = (parse(m[2] || "", 511, false, 32) + 1), int32ToString(copyOfStruct)));
        }
        else {
            return Slip__get_Caption(head) + "1";
        }
    }
    else {
        return "1";
    }
}

export class AdminModels_TeamRecord extends Record {
    constructor(TeamId, TeamName, TeamStatus, EntryToken) {
        super();
        this.TeamId = (TeamId | 0);
        this.TeamName = TeamName;
        this.TeamStatus = TeamStatus;
        this.EntryToken = EntryToken;
    }
}

export function AdminModels_TeamRecord_$reflection() {
    return record_type("OpenQuiz.Shared.AdminModels.TeamRecord", [], AdminModels_TeamRecord, () => [["TeamId", int32_type], ["TeamName", string_type], ["TeamStatus", TeamStatus_$reflection()], ["EntryToken", string_type]]);
}

export class AdminModels_TeamCard extends Record {
    constructor(TeamId, TeamName, TeamStatus, EntryToken, RegistrationDate) {
        super();
        this.TeamId = (TeamId | 0);
        this.TeamName = TeamName;
        this.TeamStatus = TeamStatus;
        this.EntryToken = EntryToken;
        this.RegistrationDate = RegistrationDate;
    }
}

export function AdminModels_TeamCard_$reflection() {
    return record_type("OpenQuiz.Shared.AdminModels.TeamCard", [], AdminModels_TeamCard, () => [["TeamId", int32_type], ["TeamName", string_type], ["TeamStatus", TeamStatus_$reflection()], ["EntryToken", string_type], ["RegistrationDate", class_type("System.DateTime")]]);
}

export class AdminModels_TourControlCard extends Record {
    constructor(Name, Seconds, Status, QwIdx, QwPartIdx, IsMediaDisplayed, IsQuestionDisplayed, Slip, StartTime) {
        super();
        this.Name = Name;
        this.Seconds = (Seconds | 0);
        this.Status = Status;
        this.QwIdx = (QwIdx | 0);
        this.QwPartIdx = (QwPartIdx | 0);
        this.IsMediaDisplayed = IsMediaDisplayed;
        this.IsQuestionDisplayed = IsQuestionDisplayed;
        this.Slip = Slip;
        this.StartTime = StartTime;
    }
}

export function AdminModels_TourControlCard_$reflection() {
    return record_type("OpenQuiz.Shared.AdminModels.TourControlCard", [], AdminModels_TourControlCard, () => [["Name", string_type], ["Seconds", int32_type], ["Status", TourStatus_$reflection()], ["QwIdx", int32_type], ["QwPartIdx", int32_type], ["IsMediaDisplayed", bool_type], ["IsQuestionDisplayed", bool_type], ["Slip", Slip_$reflection()], ["StartTime", option_type(class_type("System.DateTime"))]]);
}

export class AdminModels_QuizControlCard extends Record {
    constructor(QuizStatus, PackageId, PackageSlipIdx, CurrentTour, StreamUrl) {
        super();
        this.QuizStatus = QuizStatus;
        this.PackageId = PackageId;
        this.PackageSlipIdx = PackageSlipIdx;
        this.CurrentTour = CurrentTour;
        this.StreamUrl = StreamUrl;
    }
}

export function AdminModels_QuizControlCard_$reflection() {
    return record_type("OpenQuiz.Shared.AdminModels.QuizControlCard", [], AdminModels_QuizControlCard, () => [["QuizStatus", QuizStatus_$reflection()], ["PackageId", option_type(int32_type)], ["PackageSlipIdx", option_type(int32_type)], ["CurrentTour", option_type(AdminModels_TourControlCard_$reflection())], ["StreamUrl", option_type(string_type)]]);
}

export class AdminModels_Answer extends Record {
    constructor(Txt, Jpd, RT, Res, IsA, UT) {
        super();
        this.Txt = Txt;
        this.Jpd = Jpd;
        this.RT = RT;
        this.Res = Res;
        this.IsA = IsA;
        this.UT = UT;
    }
}

export function AdminModels_Answer_$reflection() {
    return record_type("OpenQuiz.Shared.AdminModels.Answer", [], AdminModels_Answer, () => [["Txt", string_type], ["Jpd", bool_type], ["RT", class_type("System.DateTime")], ["Res", option_type(decimal_type)], ["IsA", bool_type], ["UT", option_type(class_type("System.DateTime"))]]);
}

export class AdminModels_QuestionRecord extends Record {
    constructor(Key, Nm, Sec, TS, ST, Pt, JpdPt, Ch, Ann, Awr) {
        super();
        this.Key = Key;
        this.Nm = Nm;
        this.Sec = (Sec | 0);
        this.TS = TS;
        this.ST = ST;
        this.Pt = Pt;
        this.JpdPt = JpdPt;
        this.Ch = Ch;
        this.Ann = Ann;
        this.Awr = Awr;
    }
}

export function AdminModels_QuestionRecord_$reflection() {
    return record_type("OpenQuiz.Shared.AdminModels.QuestionRecord", [], AdminModels_QuestionRecord, () => [["Key", QwKey_$reflection()], ["Nm", string_type], ["Sec", int32_type], ["TS", TourStatus_$reflection()], ["ST", option_type(class_type("System.DateTime"))], ["Pt", decimal_type], ["JpdPt", option_type(decimal_type)], ["Ch", bool_type], ["Ann", string_type], ["Awr", string_type]]);
}

export class AdminModels_TeamAnswersRecord extends Record {
    constructor(Id, Nm, Awrs) {
        super();
        this.Id = (Id | 0);
        this.Nm = Nm;
        this.Awrs = Awrs;
    }
}

export function AdminModels_TeamAnswersRecord_$reflection() {
    return record_type("OpenQuiz.Shared.AdminModels.TeamAnswersRecord", [], AdminModels_TeamAnswersRecord, () => [["Id", int32_type], ["Nm", string_type], ["Awrs", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [QwKey_$reflection(), AdminModels_Answer_$reflection()])]]);
}

export class AdminModels_Range extends Record {
    constructor(From, To) {
        super();
        this.From = (From | 0);
        this.To = (To | 0);
    }
}

export function AdminModels_Range_$reflection() {
    return record_type("OpenQuiz.Shared.AdminModels.Range", [], AdminModels_Range, () => [["From", int32_type], ["To", int32_type]]);
}

export class AdminModels_AnswersBundle extends Record {
    constructor(Questions, Teams) {
        super();
        this.Questions = Questions;
        this.Teams = Teams;
    }
}

export function AdminModels_AnswersBundle_$reflection() {
    return record_type("OpenQuiz.Shared.AdminModels.AnswersBundle", [], AdminModels_AnswersBundle, () => [["Questions", list_type(AdminModels_QuestionRecord_$reflection())], ["Teams", list_type(AdminModels_TeamAnswersRecord_$reflection())]]);
}

export function AdminModels_TourControlCard__SecondsLeft_7F9DDECF(x, now) {
    const matchValue = x.StartTime;
    if (matchValue != null) {
        const matchValue_1 = ((x.Seconds + 10) - ~~totalSeconds(op_Subtraction(now, matchValue))) | 0;
        if (matchValue_1 > 0) {
            return matchValue_1 | 0;
        }
        else {
            return 0;
        }
    }
    else {
        return x.Seconds | 0;
    }
}

export function AdminModels_TourControlCard__IsCoundownActive_7F9DDECF(x, now) {
    if (equals(x.Status, new TourStatus(1, []))) {
        return AdminModels_TourControlCard__SecondsLeft_7F9DDECF(x, now) > 0;
    }
    else {
        return false;
    }
}

export function AdminModels_TourControlCard__get_IsLastPart(x) {
    return x.QwPartIdx >= Slip__LastQwPartIdx_Z524259A4(x.Slip, x.QwIdx);
}

export function AdminModels_TourControlCard__get_IsLastQuestionAndPart(x) {
    if (x.QwIdx >= Slip__get_LastQwIdx(x.Slip)) {
        return x.QwPartIdx >= Slip__LastQwPartIdx_Z524259A4(x.Slip, x.QwIdx);
    }
    else {
        return false;
    }
}

export function AdminModels_TourControlCard__get_IsReadyForCountdown(x) {
    const matchValue = x.Slip;
    if (matchValue.tag === 1) {
        return x.QwIdx > Slip__get_LastQwIdx(x.Slip);
    }
    else {
        return x.QwPartIdx >= SingleSlip__get_LastPartIdx(matchValue.fields[0]);
    }
}

export function AdminModels_TourControlCard__get_NeedToDisplayMedia(x) {
    const matchValue = x.Slip;
    if (matchValue.tag === 1) {
        return false;
    }
    else if (matchValue.fields[0].QuestionMedia != null) {
        return !x.IsMediaDisplayed;
    }
    else {
        return false;
    }
}

export function AdminModels_TourControlCard__get_IsSingleMultipart(x) {
    const matchValue = x.Slip;
    if (matchValue.tag === 1) {
        return false;
    }
    else {
        return SingleSlip__get_LastPartIdx(matchValue.fields[0]) > 0;
    }
}

export function AdminModels_TourControlCard__get_NeedToDisplayQuestion(x) {
    const matchValue = x.Slip;
    if (matchValue.tag === 1) {
        return false;
    }
    else if ((SingleSlip__get_LastPartIdx(matchValue.fields[0]) === 0) && !AdminModels_TourControlCard__get_NeedToDisplayMedia(x)) {
        return !x.IsQuestionDisplayed;
    }
    else {
        return false;
    }
}

export function AdminModels_TeamAnswersRecord__GetAw_Z4F1B94C2(x, idx) {
    let matchValue;
    let outArg = defaultOf();
    matchValue = [FSharpMap__TryGetValue(x.Awrs, idx, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return void 0;
    }
}

export function AdminModels_TeamAnswersRecord__UpdateAwr(x, idx, aw) {
    return new AdminModels_TeamAnswersRecord(x.Id, x.Nm, FSharpMap__Add(x.Awrs, idx, aw));
}

export function AdminModels_AnswersBundle__GetQw_Z4F1B94C2(x, idx) {
    return tryFind((qw) => equals(qw.Key, idx), x.Questions);
}

export function AdminModels_AnswersBundle__GetAw(x, teamId, idx) {
    const matchValue = tryFind((t) => (t.Id === teamId), x.Teams);
    if (matchValue == null) {
        return void 0;
    }
    else {
        return AdminModels_TeamAnswersRecord__GetAw_Z4F1B94C2(matchValue, idx);
    }
}

export function AdminModels_AnswersBundle__FindAnswers(x, idx, txt, jpd) {
    return map((tupledArg_1) => [tupledArg_1[0], value_1(tupledArg_1[1])], filter((tupledArg) => {
        const a = tupledArg[1];
        if ((a != null) && (value_1(a).Txt === txt)) {
            return value_1(a).Jpd === jpd;
        }
        else {
            return false;
        }
    }, map((t) => [t.Id, AdminModels_TeamAnswersRecord__GetAw_Z4F1B94C2(t, idx)], x.Teams)));
}

export function AdminModels_AnswersBundle__UpdateAnswers(x, idx, answersToUpdate) {
    return new AdminModels_AnswersBundle(x.Questions, map((team) => {
        let matchValue;
        let outArg = defaultOf();
        matchValue = [FSharpMap__TryGetValue(answersToUpdate, team.Id, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        if (matchValue[0]) {
            return AdminModels_TeamAnswersRecord__UpdateAwr(team, idx, matchValue[1]);
        }
        else {
            return team;
        }
    }, x.Teams));
}

export class TeamModels_QuizCard extends Record {
    constructor(QS, TS, Img, Wcm, Fwl, TC, Aw, LT, RT, Mxlr, Url, V) {
        super();
        this.QS = QS;
        this.TS = TS;
        this.Img = Img;
        this.Wcm = Wcm;
        this.Fwl = Fwl;
        this.TC = TC;
        this.Aw = Aw;
        this.LT = LT;
        this.RT = RT;
        this.Mxlr = Mxlr;
        this.Url = Url;
        this.V = (V | 0);
    }
}

export function TeamModels_QuizCard_$reflection() {
    return record_type("OpenQuiz.Shared.TeamModels.QuizCard", [], TeamModels_QuizCard, () => [["QS", QuizStatus_$reflection()], ["TS", TeamStatus_$reflection()], ["Img", string_type], ["Wcm", string_type], ["Fwl", string_type], ["TC", option_type(TourCard_$reflection())], ["Aw", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [int32_type, tuple_type(string_type, bool_type)])], ["LT", string_type], ["RT", string_type], ["Mxlr", option_type(string_type)], ["Url", option_type(string_type)], ["V", int32_type]]);
}

export class TeamModels_TeamHistoryRecord extends Record {
    constructor(QwKey, QwName, QwAw, AwTxt, AwJpd, Result, Vote) {
        super();
        this.QwKey = QwKey;
        this.QwName = QwName;
        this.QwAw = QwAw;
        this.AwTxt = AwTxt;
        this.AwJpd = AwJpd;
        this.Result = Result;
        this.Vote = Vote;
    }
}

export function TeamModels_TeamHistoryRecord_$reflection() {
    return record_type("OpenQuiz.Shared.TeamModels.TeamHistoryRecord", [], TeamModels_TeamHistoryRecord, () => [["QwKey", QwKey_$reflection()], ["QwName", string_type], ["QwAw", string_type], ["AwTxt", option_type(string_type)], ["AwJpd", bool_type], ["Result", option_type(decimal_type)], ["Vote", option_type(bool_type)]]);
}

export function TeamModels_QuizCard__get_Msg(x) {
    const matchValue = x.QS;
    switch (matchValue.tag) {
        case 2:
            return x.Fwl;
        default:
            return x.Wcm;
    }
}

export function TeamModels_TeamHistoryRecord__get_AnswerReceived(x) {
    return x.AwTxt != null;
}

export class AudModels_QuizCard extends Record {
    constructor(QS, QN, Img, Wcm, Fwl, TC, LT, RT, Mxlr, Url, V) {
        super();
        this.QS = QS;
        this.QN = QN;
        this.Img = Img;
        this.Wcm = Wcm;
        this.Fwl = Fwl;
        this.TC = TC;
        this.LT = LT;
        this.RT = RT;
        this.Mxlr = Mxlr;
        this.Url = Url;
        this.V = (V | 0);
    }
}

export function AudModels_QuizCard_$reflection() {
    return record_type("OpenQuiz.Shared.AudModels.QuizCard", [], AudModels_QuizCard, () => [["QS", QuizStatus_$reflection()], ["QN", string_type], ["Img", string_type], ["Wcm", string_type], ["Fwl", string_type], ["TC", option_type(TourCard_$reflection())], ["LT", string_type], ["RT", string_type], ["Mxlr", option_type(string_type)], ["Url", option_type(string_type)], ["V", int32_type]]);
}

export class AudModels_HistoryRecord extends Record {
    constructor(QwKey, QwName, QwAw) {
        super();
        this.QwKey = QwKey;
        this.QwName = QwName;
        this.QwAw = QwAw;
    }
}

export function AudModels_HistoryRecord_$reflection() {
    return record_type("OpenQuiz.Shared.AudModels.HistoryRecord", [], AudModels_HistoryRecord, () => [["QwKey", QwKey_$reflection()], ["QwName", string_type], ["QwAw", string_type]]);
}

export function AudModels_QuizCard__get_Msg(x) {
    const matchValue = x.QS;
    switch (matchValue.tag) {
        case 2:
            return x.Fwl;
        default:
            return x.Wcm;
    }
}

const Infra_prefix = "media";

export function Infra_routeBuilder(clientPath, typeName, methodName) {
    return toText(printf("%s/api/%s/%s"))(clientPath)(typeName)(methodName);
}

export function Infra_s3KeyForMedia(key) {
    return toText(printf("%s/%s"))(Infra_prefix)(key);
}

export function Infra_urlForMedia(mediaHost, key) {
    if (key.indexOf(".") >= 0) {
        return key;
    }
    else {
        return toText(printf("%s/%s/%s"))(mediaHost)(Infra_prefix)(key);
    }
}

export function Infra_urlForMediaPlain(mediaHost, key) {
    return toText(printf("%s/%s/%s"))(mediaHost)(Infra_prefix)(key);
}

export function Infra_urlForMediaOrDefault(mediaHost, key, defaultKey) {
    return Infra_urlForMedia(mediaHost, (key !== "") ? key : defaultKey);
}

export function Infra_urlForMediaImgSafe(mediaHost, key) {
    return Infra_urlForMedia(mediaHost, (key !== "") ? key : Infra_defaultMediaImg256);
}

export const Infra_defaultMediaImg256 = "/logo256.png";

export const Infra_defaultMediaImg = "/logo.png";

